module.exports = __webpack_public_path__ + "img/live_conference.05a96308.svg";